import React, {
    useEffect,
    useState,
    useCallback
} from "react";


import {
    Card,
    Row,
    Col,
    Button,
    Input,
    Statistic,
    Grid,
    Tag,
    Form,
    Avatar,
    Pagination,
    Modal,
    Select,
    Table
} from "antd";

import {
    PlusOutlined,
    SearchOutlined,
    UserOutlined
} from "@ant-design/icons";


import {
    motion
} from "framer-motion";


import Swal from "sweetalert2";


import api from "../api/api";


import {
    useAcademicYear
} from "../AcademicYearContext";



const {
    useBreakpoint
}=Grid;





// ==========================================
// COLOR SYSTEM
// ==========================================


const COLORS={

    black:"#111827",

    darkBlack:"#0B1120",

    gray:"#6B7280",

    lightGray:"#F3F4F6",

    border:"#E5E7EB",

    white:"#FFFFFF",

    orange:"#F97316",

    orangeLight:"#FFF7ED",

    green:"#22C55E",

    red:"#EF4444",

    chameleon:"#84CC16"

};








const NewBlackList=()=>{


const {
    selectedYear
}=useAcademicYear();



const screens=useBreakpoint();



// ==========================================
// STATES
// ==========================================


const [
    blacklist,
    setBlacklist
]=useState([]);



const [
    students,
    setStudents
]=useState([]);



const [
    loading,
    setLoading
]=useState(false);



const [
    studentLoading,
    setStudentLoading
]=useState(false);



const [
    page,
    setPage
]=useState(1);



const [
    total,
    setTotal
]=useState(0);



const [
    search,
    setSearch
]=useState("");



const [
    modal,
    setModal
]=useState(false);



const [
    editing,
    setEditing
]=useState(null);



const [
    selectedStudent,
    setSelectedStudent
]=useState(null);



const [
    form
]=Form.useForm();








// ==========================================
// FETCH BLACKLIST STUDENTS
// ==========================================


const fetchBlacklist=useCallback(
async()=>{


if(!selectedYear)
return;



try{


setLoading(true);



const response=
await api.get(
"/blacklisted-students/",
{

params:{

page,

page_size:10,

search,

student__academic_year:selectedYear.id

}

}

);



setBlacklist(
response.data.results || []
);



setTotal(
response.data.count || 0
);



}

catch(error){


console.log(error);


Swal.fire(
"Error",
"Unable to load blacklist students",
"error"
);


}

finally{


setLoading(false);


}



},
[
selectedYear,
page,
search
]
);







useEffect(()=>{


fetchBlacklist();


},[
fetchBlacklist
]);









// ==========================================
// FETCH AVAILABLE STUDENTS
// ==========================================


const fetchStudents=
async(
value=""
)=>{


if(!selectedYear)
return;



try{


setStudentLoading(true);



const response=
await api.get(
"/blacklisted-students/available-for-blacklist/",
{

params:{

academic_year:selectedYear.id,

search:value

}

}

);



setStudents(
response.data || []
);



}

catch(error){


console.log(error);


}

finally{


setStudentLoading(false);


}


};









// ==========================================
// SAVE BLACKLIST
// ==========================================


const saveBlacklist=
async(values)=>{


try{


if(editing){



await api.patch(

`/blacklisted-students/${editing.id}/`,

{

reason:values.reason

}

);



Swal.fire(
"Updated",
"Updated successfully",
"success"
);



}

else{


await api.post(

"/blacklisted-students/",

{

student:values.student,

reason:values.reason

}

);



Swal.fire(
"Success",
"Student added to blacklist",
"success"
);



}



setModal(false);


form.resetFields();


setSelectedStudent(null);


fetchBlacklist();



}


catch(error){


Swal.fire(
"Error",

error.response?.data?.detail ||
"Operation failed",

"error"
);


}


};









// ==========================================
// REMOVE BLACKLIST STUDENT
// ==========================================


const removeStudent=
async(id)=>{


const result=
await Swal.fire({

title:"Remove student?",

text:"Student will become available again",

icon:"warning",

showCancelButton:true,

confirmButtonColor:COLORS.red,

confirmButtonText:"Remove"

});



if(!result.isConfirmed)
return;



try{


await api.delete(

`/blacklisted-students/${id}/`

);



Swal.fire(
"Removed",
"Student removed from blacklist",
"success"
);



fetchBlacklist();



}

catch(error){


Swal.fire(
"Error",
"Unable to remove student",
"error"
);



}


};









// ==========================================
// OPEN CREATE
// ==========================================


const openCreate=()=>{


setEditing(null);


setSelectedStudent(null);


form.resetFields();


setModal(true);


fetchStudents();



};









// ==========================================
// OPEN EDIT
// ==========================================


const openEdit=(record)=>{


setEditing(record);


form.setFieldsValue({

reason:record.reason

});



setModal(true);



};









// ==========================================
// START JSX
// ==========================================


return (


<motion.div


initial={{

opacity:0,

y:20

}}


animate={{

opacity:1,

y:0

}}


style={{

background:"#F9FAFB",

minHeight:"100vh",

padding:

screens.md
?
24
:
12

}}

>






{/* =====================================
 PREMIUM HEADER
===================================== */}



<Card


bordered={false}


style={{

background:

`linear-gradient(
135deg,
${COLORS.black},
${COLORS.darkBlack}
)`,

borderRadius:22,

marginBottom:24

}}

>



<Row


justify="space-between"


align="middle"


gutter={[16,16]}


>



<Col

xs={24}

md={16}

>


<h1


style={{

color:"#FFFFFF",

fontSize:

screens.md
?
30
:
22,

fontWeight:800,

margin:0

}}


>


 Student Management


</h1>



<p


style={{

color:"#D1D5DB",

marginTop:8,

marginBottom:0

}}


>


Where the magic happens! Manage your students with ease and efficiency.


</p>



</Col>






<Col

xs={24}

md={8}

style={{

textAlign:

screens.md
?
"right"
:
"left"

}}

>


<Button


type="primary"


icon={<PlusOutlined />}


onClick={openCreate}


style={{

background:COLORS.orange,

border:"none",

borderRadius:12,

height:46,

fontWeight:700

}}

>


Add Student


</Button>



</Col>




</Row>



</Card>









{/* =====================================
STATISTICS CARDS
===================================== */}



<Row


gutter={[20,20]}


style={{

marginBottom:24

}}


>



<Col

xs={24}

sm={12}

lg={8}

>


<Card

bordered={false}

style={{

borderRadius:18

}}

>


<Statistic


title="Listed Students"


value={blacklist.length}


valueStyle={{

color:COLORS.red,

fontWeight:800

}}


/>



<Tag

color="red"

style={{

marginTop:10,

borderRadius:20

}}

>

Students Records

</Tag>



</Card>



</Col>







<Col

xs={24}

sm={12}

lg={8}

>


<Card

bordered={false}

style={{

borderRadius:18

}}

>


<Statistic


title="Available Students"


value={students.length}


valueStyle={{

color:COLORS.orange,

fontWeight:800

}}


/>



<Tag

color="orange"

style={{

marginTop:10,

borderRadius:20

}}

>

Ready To Add

</Tag>



</Card>



</Col>







<Col

xs={24}

sm={24}

lg={8}

>


<Card

bordered={false}

style={{

borderRadius:18

}}

>


<Statistic


title="Academic Year"


value={
selectedYear?.name || "-"
}


valueStyle={{

color:COLORS.black,

fontWeight:800

}}


/>



<Tag

color="green"

style={{

marginTop:10,

borderRadius:20

}}

>

Active Year

</Tag>



</Card>



</Col>




</Row>









{/* =====================================
SEARCH SECTION
===================================== */}



<Card


bordered={false}


style={{

borderRadius:18,

marginBottom:24

}}



>



<Row


align="middle"


gutter={[16,16]}


>



<Col

xs={24}

md={16}

>



<Input


size="large"


allowClear


prefix={

<SearchOutlined

style={{

color:COLORS.orange

}}

/>

}


placeholder="Search blacklist students..."


value={search}


onChange={(e)=>{


setPage(1);


setSearch(
e.target.value
);


}}


style={{

borderRadius:12

}}



/>



</Col>






<Col

xs={24}

md={8}

>


<Tag


style={{

background:COLORS.orangeLight,

color:COLORS.orange,

border:"none",

padding:"8px 16px",

borderRadius:20,

fontWeight:700

}}


>


Academic Year:

{" "}

{selectedYear?.name}


</Tag>



</Col>




</Row>


</Card>






<Card


bordered={false}


style={{

borderRadius:20,

overflow:"hidden"

}}



>


<Table

loading={loading}

dataSource={blacklist}

rowKey="id"

pagination={false}

scroll={{

x:1000

}}

columns={[


{


title:"Student",


key:"student",


fixed:"left",


width:280,


render:(_,record)=>{


const student =
record.student || {};



return (


<div

style={{

display:"flex",

alignItems:"center",

gap:14

}}

>



<Avatar


size={55}


src={

student.student_admission_image

}


style={{

background:COLORS.orange

}}


>


{

!student.student_admission_image &&

<UserOutlined />

}


</Avatar>





<div>



<div


style={{

fontWeight:800,

fontSize:15,

color:COLORS.black

}}


>


{
student.full_name ||
"Unknown Student"
}


</div>




<div


style={{

fontSize:13,

color:COLORS.gray

}}


>


{
student.email ||
"No email"

}


</div>




<div


style={{

fontSize:12,

color:"#9CA3AF"

}}


>


ID:

{" "}

{

student.id

}



</div>




</div>




</div>


);


}



},







{


title:"Academic Information",


key:"academic",


width:230,


render:(_,record)=>{


const student =
record.student || {};



return (



<div>


<div

style={{

fontWeight:700

}}

>

{

student.grade_class_name ||

"N/A"

}


</div>




<div

style={{

color:COLORS.gray,

fontSize:13

}}

>


{

student.division_assigned_name ||

"N/A"

}



</div>




<div

style={{

color:"#9CA3AF",

fontSize:12

}}

>


{

student.current_academic_year ||

"N/A"

}



</div>



</div>



);


}


},







{


title:"Reason",


dataIndex:"reason",


key:"reason",


width:250,


render:(value)=>{


return (


<div

style={{

maxWidth:230,

whiteSpace:"normal"

}}

>


{

value ||

"No reason provided"

}



</div>


);


}


},







{


title:"Status",


key:"status",


width:150,


render:()=>{


return (


<Tag


style={{

borderRadius:20,

padding:"6px 14px",

fontWeight:700

}}


color="red"



>


BLACKLISTED


</Tag>


);


}



},







{


title:"Student Status",


key:"student_status",


width:150,


render:(_,record)=>{


const student =
record.student || {};



return (



<Tag


color={

student.status==="Enrolled"

?

"green"

:

"orange"

}


style={{

borderRadius:20

}}

>


{

student.status ||

"N/A"

}



</Tag>



);


}



},







{


title:"Actions",


key:"actions",


fixed:"right",


width:160,


render:(_,record)=>{


return (



<div

style={{

display:"flex",

gap:10

}}

>



<Button


type="default"


onClick={()=>openEdit(record)}


style={{

borderRadius:10,

color:COLORS.orange,

borderColor:COLORS.orange

}}



>


Edit


</Button>







<Button


danger


type="primary"


onClick={()=>removeStudent(record.id)}


style={{

borderRadius:10

}}


>


Delete


</Button>




</div>



);


}



}



]}


/>



</Card>









{/* =====================================
 PAGINATION
===================================== */}



<Row


justify="end"


style={{

marginTop:24

}}



>



<Pagination


current={page}


pageSize={10}


total={total}


showSizeChanger={false}


onChange={(value)=>{


setPage(value);



}}



/>



</Row>


<Modal


open={modal}


centered


width={650}


footer={null}


title={

<div

style={{

fontWeight:800,

fontSize:18

}}

>


{

editing

?

"Update The Student Record"

:

"The Student"

}



</div>

}


onCancel={()=>{


setModal(false);


setSelectedStudent(null);


}}



>



<Form


form={form}


layout="vertical"


onFinish={saveBlacklist}



>





{

!editing &&


<Form.Item


name="student"


label="Select Student"


rules={[

{

required:true,

message:"Please select student"

}

]}



>



<Select


showSearch


allowClear


loading={studentLoading}


filterOption={false}


placeholder="Search student name..."


onDropdownVisibleChange={(open)=>{


if(open){

fetchStudents();

}


}}



onSearch={(value)=>{


fetchStudents(value);


}}



onChange={(value)=>{


const student =

students.find(

item=>item.id===value

);



setSelectedStudent(student || null);



}}



style={{

height:50

}}



options={

students.map(student=>(


{


value:student.id,


label:(



<div


style={{

display:"flex",

alignItems:"center",

gap:12,

padding:"8px 0"

}}

>



<Avatar


size={45}


src={

student.student_admission_image

}


icon={<UserOutlined />}



/>





<div>



<div


style={{

fontWeight:700

}}


>


{

student.full_name

}


</div>




<div


style={{

fontSize:12,

color:COLORS.gray

}}



>


{

student.grade_class_name

}

{" - "}

{

student.division_assigned_name

}



</div>



</div>




</div>



)


}



))

}




/>



</Form.Item>



}









{/* =====================================
 STUDENT PREVIEW
===================================== */}



{

selectedStudent && !editing &&


<Card


style={{

background:COLORS.orangeLight,

borderRadius:18,

marginBottom:20

}}


bordered={false}


>



<Row

align="middle"

gutter={20}

>



<Col>


<Avatar


size={75}


src={

selectedStudent.student_admission_image

}


icon={<UserOutlined />}


/>


</Col>






<Col flex="auto">



<h3

style={{

margin:0,

fontWeight:800

}}

>


{

selectedStudent.full_name

}



</h3>





<p

style={{

margin:4,

color:COLORS.gray

}}

>


Email:

{" "}

{

selectedStudent.email ||

"N/A"

}



</p>






<p

style={{

margin:4,

color:COLORS.gray

}}

>


Class:

{" "}

{

selectedStudent.grade_class_name

}



</p>






<p

style={{

margin:4,

color:COLORS.gray

}}

>


Division:

{" "}

{

selectedStudent.division_assigned_name

}



</p>






<p

style={{

margin:4,

color:COLORS.gray

}}

>


Academic Year:

{" "}

{

selectedStudent.current_academic_year

}



</p>




</Col>



</Row>




</Card>



}









<Form.Item


name="reason"


label="Reason"


rules={[

{

required:true,

message:"Please provide reason"

}

]}



>



<Input.TextArea


rows={5}


placeholder="Enter blacklist reason..."


style={{

borderRadius:12

}}



/>


</Form.Item>








<Button


htmlType="submit"


type="primary"


block


size="large"


style={{

background:COLORS.orange,

border:"none",

borderRadius:12,

height:48,

fontWeight:700

}}



>



{

editing

?

"Update Record"

:

"Save Record"

}



</Button>





</Form>



</Modal>









</motion.div>


);



};



export default NewBlackList;




